module.exports = __webpack_public_path__ + "img/home-hero-fallback.f082b3b0.jpg";